import services from 'services/services';

// Import types
import type { SubscriptionCreatePayload, SubscriptionCreateResponse } from 'types/api/packetsSubscription';
import type { CalculatePriceAction } from 'types/api/packetsSubscription/calculatePrice';

export type SubscriptionCreateParams = {
	action: CalculatePriceAction | null;
	payload: SubscriptionCreatePayload;
};

export const fetchSubscriptionCreate = ({ action, payload }: SubscriptionCreateParams) => {
	switch (action) {
		case 'new_subscription':
			return services.post<SubscriptionCreateResponse>(`/packetsSubscription/create`, payload);

		case 'add_additional_products':
			return services.post<SubscriptionCreateResponse>(`/packetsSubscription/addAdditionalPackets`, payload);

		default:
			return services.put<SubscriptionCreateResponse>(`/packetsSubscription/update`, payload);
	}
};
